function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import Api, { ROUTES } from "./api";
import ConditionsFunctions from "./functions";
import Logger from "./logger";
var Collector = {
  //---------------
  // API METHOD
  // --------------
  getDiag: function getDiag(id) {
    if (!id) {
      return null;
    }
    return Api.get(ROUTES.DIAGNOSTIC.replace(':id', id));
  },
  getApiQuestion: function getApiQuestion(id) {
    if (!id) {
      return null;
    }
    return Api.get(ROUTES.QUESTIONS.replace(':id', id));
  },
  getApiBloc: function getApiBloc(id) {
    if (!id) {
      return null;
    }
    return Api.get(ROUTES.BLOCS.replace(':id', id));
  },
  getCircularReplacer: function getCircularReplacer() {
    var seen = new WeakSet();
    return function (key, value) {
      if (_typeof(value) === 'object' && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  },
  // Permet de supprimer les références circulaire dans l'objet de
  // facon plutôt safe.
  removeCircular: function removeCircular(obj) {
    if (!obj || Object.keys(obj).length === 0) {
      return;
    }
    var seen = new Map();
    var _recurse = function recurse(obj) {
      seen.set(obj, true);
      if (null === obj) return;
      Object.entries(obj).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];
        if (_typeof(v) !== 'object') return;
        if (seen.has(v)) delete obj[k];else _recurse(v);
      });
    };
    _recurse(obj);
  },
  getNextQuestion: function getNextQuestion(diagId, order, responses) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var tmpResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            tmpResponse = responses;
            if (tmpResponse && !Array.isArray(tmpResponse) && Object.keys(tmpResponse).length > 0) {
              Collector.removeCircular(tmpResponse);
            }
            return _context.abrupt("return", Api.post(ROUTES.NEXT_QUESTION.replace(':id', diagId), {
              diagId: diagId,
              order: order,
              currentResponses: tmpResponse
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  //---------------------
  // Diag Reader Method
  //---------------------
  getBloc: function getBloc(diag, order) {
    return diag.blocs.filter(function (bloc) {
      return bloc.order === "".concat(order);
    })[0];
  },
  getQuestion: function getQuestion(bloc, currentOrder) {
    var order = "".concat(bloc.order, ".").concat(currentOrder);

    // return object or undefined
    return bloc.questions.filter(function (question) {
      return question.order === order;
    })[0];
  },
  checkRepeatConditions: function checkRepeatConditions(question, diagResponses) {
    var repeatConditions = question.repeatConditions;
    if (!repeatConditions || repeatConditions.length === 0) {
      return true;
    }
    var matches = null;
    var length = repeatConditions.length;
    if (repeatConditions && length > 0) {
      for (var r = 0; r < length; ++r) {
        var _repeatConditions$r = repeatConditions[r],
          conditions = _repeatConditions$r.conditions,
          number = _repeatConditions$r.number;
        matches = this.checkDisplayConditions(question, diagResponses, conditions, true);
        var repeat = number && number > 0 ? number : matches;
        return matches ? {
          repeat: repeat
        } : false;
      }
      return false;
    }
    return true;
  },
  checkDisplayConditions: function checkDisplayConditions(question, diagResponses) {
    var displayConditionParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var returnMatches = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var displayConditions = displayConditionParams;
    if (!displayConditions) {
      displayConditions = question.displayConditions;
    }
    if (!displayConditions || displayConditions.length === 0) {
      return true;
    }
    var _displayConditions = displayConditions,
      length = _displayConditions.length;
    var matches = [];
    var response = null;
    if (displayConditions && length > 0) {
      for (var d = 0; d < length; ++d) {
        var _displayConditions$d = displayConditions[d],
          parameters = _displayConditions$d.parameters,
          type = _displayConditions$d.type;
        var responses = parameters.responses;
        switch (type.alias) {
          case 'f_contains':
            response = ConditionsFunctions.contains(responses, diagResponses, returnMatches);
            if (!response) {
              return false;
            }
            if (returnMatches) {
              matches = matches.concat(response);
            }
            break;
          case 'f_and':
            // eslint-disable-line no-console
            break;
          default:
        }
      }
      if (returnMatches) {
        return matches;
      }
    }
    return true;
  },
  getContentForOrder: function getContentForOrder(object, order) {
    var content = Collector.getQuestion(object, order);
    if (!content) {
      content = Collector.getBloc(object, order);
    }
    return content;
  },
  saveResponse: function saveResponse(questionId, responses) {
    // eslint-disable-line no-console
    // Save it.
  },
  /**
   * Extract a response
   * @param {string} order
   */
  getCurrentOrderResponses: function getCurrentOrderResponses(order, responses) {
    if (!order) {
      return null;
    }
    var orders = order.split('.');
    var currentResponse = responses || {};
    for (var i = 0; i < orders.length; i++) {
      if (!currentResponse[orders[i]]) {
        currentResponse[orders[i]] = {};
      }
      currentResponse = currentResponse[orders[i]];
    }
    if (Object.keys(currentResponse).length === 0) {
      return null;
    }
    return currentResponse;
  },
  getQuestionResponseByKey: function getQuestionResponseByKey(order, responses, key) {
    var currentResponse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var question = arguments.length > 4 ? arguments[4] : undefined;
    Logger.info('fetch internal response by key');
    var response = currentResponse || Collector.getCurrentOrderResponses(order, responses);
    if (!response || !response.responses || !response.responses[key]) {
      return null;
    }
    return response.responses[key];
  },
  insertQuestionResponse: function insertQuestionResponse(key, value, order, responses, question, type, extraAlias, typeName) {
    var _question$publicParam;
    var orders = order.split('.');
    var currentResponse = responses || {};
    var max = orders.length;
    for (var i = 0; i < max; i++) {
      if (!currentResponse[orders[i]] && i < max - 2) {
        currentResponse[orders[i]] = {};
      }
      currentResponse = currentResponse[orders[i]];
    }
    if (!currentResponse.responses) {
      currentResponse.responses = {};
    }
    currentResponse.extraAlias = extraAlias;
    currentResponse.typeName = typeName;
    if (question) {
      currentResponse.question = question['@id'] || "/questions/".concat(question.id);
      currentResponse.questionAlias = question.alias;
      currentResponse.questionObj = question;
      currentResponse.questionId = question.id;
      currentResponse.loop = question.loop;
      currentResponse.extraAlias = extraAlias;
    }
    if (!key && !value) {
      // réinitialisation de la valeur
      currentResponse.responses = {};
    } else {
      // changement de valeur
      if (value) {
        currentResponse.responses[key] = value;
      } else if (!value && currentResponse.responses[key]) {
        delete currentResponse.responses[key];
      }
    }
    if (type) {
      currentResponse.type = type;
    }
    var keys = Object.keys(currentResponse.responses);

    // Question aleatoire
    if ((question === null || question === void 0 || (_question$publicParam = question.publicParameters) === null || _question$publicParam === void 0 ? void 0 : _question$publicParam.random) === 'true' && keys.length > 1) {
      var _ref3 = (question === null || question === void 0 ? void 0 : question.publicParameters) || {
          randomNumber: 2
        },
        randomNumber = _ref3.randomNumber;
      var randomizedResponses = {};
      var list = Collector.getRandomIndexes(keys.length, randomNumber);
      list.forEach(function (index) {
        randomizedResponses[keys[index]] = currentResponse.responses[keys[index]];
      });
      currentResponse.randomResponses = randomizedResponses;
    }
    return currentResponse;
  },
  getRandomIndex: function getRandomIndex(range) {
    return Math.abs(parseInt(Math.random() * range));
  },
  getRandomIndexes: function getRandomIndexes(length, numberOfRandom) {
    var list = [];
    for (var i = 0; i < parseInt(numberOfRandom); i++) {
      var index = Collector.getRandomIndex(length);
      while (list.includes(index)) {
        index = Collector.getRandomIndex(length);
      }
      list.push(index);
    }
    return list;
  },
  clearResponseForOrder: function clearResponseForOrder(responses, order) {
    var orders = order.split('.');
    var currentResponse = responses || {};
    var max = orders.length;
    for (var i = 0; i < max; i++) {
      if (!currentResponse[orders[i]] && i < max - 2) {
        currentResponse[orders[i]] = {};
      }
      currentResponse = currentResponse[orders[i]];
    }
    currentResponse.responses = {};
  },
  sortDiagnostic: function sortDiagnostic(element) {
    var _this = this;
    if (element.blocs) {
      element.blocs.sort(function (blocA, blocB) {
        return blocA.order > blocB.order;
      });
      element.blocs.map(function (bloc) {
        return _this.sortDiagnostic(bloc);
      });
    }
    if (element.questions) {
      element.questions.sort(function (questionA, questionB) {
        return questionA.order > questionB.order;
      });
    }
    return element;
  },
  getQuestionByAlias: function getQuestionByAlias(responses, alias, currentOrder) {
    var formatedResponses = responses;
    if (currentOrder && currentOrder.indexOf('_loop.') > 0) {
      var subOrder = currentOrder.substring(0, currentOrder.indexOf('_loop') + 5);
      var tmp = Collector.getCurrentOrderResponses(subOrder, responses);
      if (null !== tmp) {
        formatedResponses = tmp;
      }
    }
    var keys = Object.keys(formatedResponses);
    var currentResponse = null;
    for (var kIndex = 0; kIndex < keys.length; kIndex++) {
      var response = formatedResponses[keys[kIndex]];
      if (!response.questionAlias) {
        currentResponse = Collector.getQuestionByAlias(response, alias);
        if (null !== currentResponse && currentResponse.questionAlias === alias) {
          return currentResponse;
        }
      } else if (response.questionAlias === alias) {
        return response;
      }
    }
    if (null === currentResponse && currentOrder) {
      currentResponse = Collector.getQuestionByAlias(responses, alias);
    }
    return currentResponse;
  },
  getBlocByAlias: function getBlocByAlias(responses, alias) {
    var keys = Object.keys(responses);
    var currentResponse = null;
    for (var kIndex = 0; kIndex < keys.length; kIndex++) {
      var response = responses[keys[kIndex]];
      if (keys[kIndex].indexOf(alias) !== -1) {
        return {
          responses: response,
          alias: alias
        };
      }
      if (!response.questionAlias) {
        currentResponse = Collector.getBlocByAlias(response, alias);
        if (null !== currentResponse && currentResponse.alias === alias) {
          return currentResponse;
        }
      }
    }
    return currentResponse;
  },
  deleteUnecessaryKeys: function deleteUnecessaryKeys(responses) {
    var cloned = _objectSpread({}, responses);
    var keys = Object.keys(cloned);
    for (var kIndex = 0; kIndex < keys.length; kIndex++) {
      var response = cloned[keys[kIndex]];
      if (!response.questionAlias) {
        Collector.deleteUnecessaryKeys(response);
      } else {
        delete response['questionObj'];
      }
    }
    return cloned;
  }
};
export default Collector;